<template>
  <div class="wx-merchant-container">
    <div class="wx-merchant-header">
      <div class="wx-merchant-header-left">
        微信商户号：
        <el-select v-model="wxMerchant" style="width: 200px" placeholder="请选择微信商户号" filterable @change="handleSelectMerchantChange">
          <el-option v-for="item in wxMerchantOptionList" :key="item.company_name" :label="item.company_name" :value="item.company_name">
            <span style="float: left">{{ item.company_name }}</span>
            <span v-if="item.company_complaint_count" style="float: right; color: red">{{ item.company_complaint_count }}</span>
          </el-option>
        </el-select>
      </div>
      <div class="wx-merchant-header-right">
        <el-link type="primary" :underline="false" @click="handleFsNotify">飞书通知配置</el-link>
      </div>
    </div>

    <!-- 页面区域 -->
    <div class="wx-merchant-content">
      <!-- 商户号列表 -->
      <div class="merchant-list">
        <div :class="['merchant-list-item', selectMerchantId === item.mch_id ? 'select-merchant-item' : '']" v-for="(item, index) in merchantList" :key="index" @click="handleSelectMerchant(item)">
          <div class="merchant-name" :style="{ maxWidth: item.complaint_count ?'180px' : '220px' }">{{ item.mch_name }}</div>
          <div v-if="item.complaint_count" class="merchant-count">{{ `(${item.complaint_count})` }}</div>
        </div>
      </div>

      <!-- 页面查询 -->
      <div class="merchant-search">
        <!-- 数据展示 -->
        <div class="search-content-header">
          <div class="num-content">
            <div class="num-content-item">待处理：{{ merchantOverviewData.pending_count }}</div>
            <div class="num-content-item">超时未处理：{{ merchantOverviewData.timeout_pending_count }}</div>
            <div class="num-content-item">今日已处理：{{ merchantOverviewData.today_process_count }}</div>
            <div class="num-content-item">今日已完成：{{ merchantOverviewData.today_processed_count }}</div>
            <div class="num-content-item">及时回复率：{{ merchantOverviewData.timely_response_rate }}</div>
          </div>
          <div class="searh-toooltip">
            <el-tooltip class="item" effect="dark" placement="top">
              <div slot="content">
                <p>待处理：近30天内发起的投诉单，当前处于待处理状态的单数。</p>
                <p>超时未处理：用户投诉后，商家24小时内未操作回复的投诉单。</p>
                <p>今日已处理：今日已回复、处理完成的投诉单总数。</p>
                <p>今日已完成：今日处理完成的投诉单总数。</p>
                <p>近7 天（t-14）-（t-8）内发起的所有单据在首次投诉发起后 24h 内回复的比例。</p>
              </div>
              <i class="el-icon-warning-outline"></i>
            </el-tooltip>
          </div>
        </div>

        <!-- 表格展示 -->
        <div class="search-content-table">
          <div class="search-content-table-header">
            <BaseForm
              ref="baseform"
              :model.sync="searchForm"
              inline
              :formItems="searchFormItems"
              label-width="110px"
              @search="handleSearch"
              @reset="handleReset"
            />
          </div>

          <div class="search-content-table-body">
            <BaseTableGroup
              ref="baseTableGroup"
              border
              :columns="columns"
              :data="tableData"
              :total="total"
              :loading="listLoading"
              showPage
              maxHeight="500px"
              :page="searchForm.page"
              :pageSize="searchForm.limit"
              @pageChange="onPageChange"
            />
          </div>
        </div>
      </div>
    </div>


    <!-- 飞书通知配置 -->
    <WxFsNotify ref="fsNotify" />

    <!-- 回复用户 -->
    <ReplyUser ref="replyUser" @success="handleReplaySuccess" />

    <!-- 投诉单详情 -->
    <WxComplaintFormDetail ref="complaintFormDetail" />
  </div>
</template>


<script>
import BaseForm from '@/components/common/BaseForm/BaseForm.vue';
import BaseTableGroup from '@/components/common/BaseTable/baseTableGroup.vue';

// 飞书通知配置
import WxFsNotify from './fsNotify.vue';
// 回复用户
import ReplyUser from './replyUser.vue';
import RenderDom from '@/utils/renderDom';
import { handleListApi } from '@/api/admin_user';
import WxComplaintFormDetail from './complaintFormDetail.vue';
import { getWxMerchantOptionsApi, getWxMerchantComplaintListApi, wxMerchantComplaintOverviewDataApi, wxMerchantCompleteApi } from '@/api/merchant_complain_handle'
import { getDate, debounce } from '@/utils/utils';


class DefaultSearchForm {
  constructor () {
    this.mch_id = ''; // 商户号ID
    this.page = 1;
    this.limit = 50;
    this.begin_date = getDate(-29, '', '{y}-{m}-{d} {h}:{i}:{s}'); // 投诉时间
    this.end_date = getDate(0, '', '{y}-{m}-{d} {h}:{i}:{s}'); // 投诉时间
    this.order_sn = ''; // 单号
    this.complaint_state = ''; // 投诉状态
    this.incoming_user_response = ''; // 用户留言状态
    this.user_complaint_times = ''; // 用户投诉次数
    this.timeout_state = ''; // 超时状态
  }
}

export default {
  name: 'WxMerchantPage',
  components: {
    WxFsNotify,
    ReplyUser,
    BaseForm,
    BaseTableGroup,
    RenderDom,
    WxComplaintFormDetail
  },
  data() {
    return {
      wxMerchant: '',
      wxMerchantOptionList: [], // 微信商户号下拉列表
      merchantList: [],
      selectMerchantId: '',

      handleListApi: handleListApi,
      searchForm: new DefaultSearchForm(),
      listLoading: false,
      tableData: [],
      total: 0,

      // 商户总体数据概览
      merchantOverviewData: {
        pending_count: 0, // 待处理
        timeout_pending_count: 0, // 超时未处理
        today_process_count: 0, // 今日已处理
        today_processed_count: 0, // 今日已完成
        timely_response_rate: '', // 及时回复率
      }
    };
  },
  computed: {
    columns () {
      return [
        {
          label: '微信支付订单号',
          key: 'transaction_id',
          width: '150',
          'show-overflow-tooltip': false,
          render: (h, params) => {
            // 按照微信官方解释，订单与投诉单为一对一，但接口数据格式为array，因此按照原值返回，前端可按照一对一处理
            const { complain_order = [] } = params.row
            const hasOrderInfo = Array.isArray(complain_order) && complain_order.length > 0
            return (
              <div>
                { 
                  hasOrderInfo && <div>
                    { complain_order[0].transaction_id }
                  </div>
                }
              </div>
            )
          }
        },
        {
          label: '投诉时间',
          key: 'complaint_time',
        },
        {
          label: '问题描述',
          key: 'problem_description',
        },
        {
          label: '投诉类型',
          key: 'problem_type_text',
        },
        {
          label: '订单金额(元)',
          key: 'complaint_count',
          render: (h, params) => {
            // 按照微信官方解释，订单与投诉单为一对一，但接口数据格式为array，因此按照原值返回，前端可按照一对一处理
            const { complain_order = [] } = params.row
            const hasOrderInfo = Array.isArray(complain_order) && complain_order.length > 0
            return (
              <div>
                { 
                  hasOrderInfo && <div>
                    { complain_order[0].amount }
                  </div>
                }
              </div>
            )
          }
        },
        {
          label: '申请退款金额',
          key: 'apply_refund_amount',
        },
        {
          label: '投诉描述',
          key: 'complaint_detail',
          'show-overflow-tooltip': false,
          width: '180',
          render: (h, params) => {
            const { complaint_detail = '', user_complaint_upgrade = false } = params.row
            return (
              <div>
                {
                  complaint_detail && (
                    <div>
                      <div>
                        <el-tooltip content={complaint_detail} placement="top">
                          <div class="wx-complain_content_ellipsis">{complaint_detail}</div>
                        </el-tooltip>
                      </div>
                    </div>
                  )
                }
                {
                  user_complaint_upgrade && <div style="color:red">用户升级投诉</div>
                }
              </div>
            )
          }
        },
        {
          label: '联系人',
          key: 'payer_phone',
        },
        {
          label: '投诉次数',
          key: 'user_complaint_times',
        },
        {
          label: '投诉单状态',
          key: 'complaint_state',
          render: (h, params) => {
            const dataEnum = {
              PENDING: '待处理',
              PROCESSING: '处理中',
              PROCESSED: '已处理完成',
            }
            const { incoming_user_response = 0 } = params.row
            return (
              <div>
                <div>{ dataEnum[params.row.complaint_state] || '/' }</div>
                {
                  incoming_user_response === 1 && 
                  <div style="color: #ff9c68">用户有新留言</div>
                }
              </div>
            )
          }
        },
        {
          label: '操作',
          key: 'operation',
          width: 150,
          fixed: 'right',
          render: (h, params) => {
            const { complaint_state = '' } = params.row
            // 投诉单状态=处理中 展示处理完成 
            return (
              <div style="display:flex;flex-direction: column;">
                <el-link type="primary" size="mini" underline={false} onClick={() => this.handleReplayUser(params.row)}>回复用户</el-link>
                {
                  complaint_state === 'PROCESSING' &&
                  <el-link type="primary" size="mini" underline={false} onClick={() => this.handleComplete(params.row)}>处理完成</el-link>
                }
                <el-link type="primary" size="mini" underline={false} onClick={() => this.handleSearchDetailInfo(params.row)}>查看详情</el-link>

              </div>
            )
          },
        }
      ]
    },
    searchFormItems () {
      return [
        {
          label: '投诉时间',
          child: {
            renderType: 'datePickerRange',
            value: [this.searchForm.begin_date, this.searchForm.end_date],
            beginTime: this.searchForm.begin_date,
            endTime: this.searchForm.end_date,
            'update:beginTime': (time) => {
              this.searchForm.begin_date = time
            },
            'update:endTime': (time) => {
              this.searchForm.end_date = time
            },
            styles: { width: '250px' },
            change: debounce((time) => {
              if (time) {
                const time_stamp = new Date(time[1]) - new Date(time[0])
                const time_diff = (time_stamp / 86400000) + 1
                if (time_diff > 365) {
                  this.searchForm.gmt_complaint_start = getDate(-29, '', '{y}-{m}-{d} {h}:{i}:{s}')
                  this.searchForm.gmt_complaint_end = getDate(0, '', '{y}-{m}-{d} {h}:{i}:{s}')
                  this.$message.error('起始时间间隔不能超过365天')
                  return false
                }
              }
            }, 0, false),
            clearable: false
          }
        },
        {
          label: '单号',
          child: {
            renderType: 'input',
            valueKey: 'order_sn',
            maxlength: 100
          }
        },
        {
          label: '投诉状态',
          child: {
            renderType: 'select',
            valueKey: 'complaint_state',
            options: [
              { label: '待处理', value: 'PENDING ' },
              { label: '处理中', value: 'PROCESSING' },
              { label: '已处理完成', value: 'PROCESSED' },
            ]
          }
        },
        {
          label: '用户留言状态',
          child: {
            renderType: 'select',
            valueKey: 'incoming_user_response',
            options: [
              { label: '无新留言', value: 0 },
              { label: '有新留言', value: 1 },
            ]
          }
        },
        {
          label: '用户投诉次数',
          child: {
            renderType: 'select',
            valueKey: 'user_complaint_times',
            options: [
              { label: '1次', value: '1' },
              { label: '>1次', value: '>1' },
              { label: '>2次', value: '>2' },
              { label: '>3次', value: '>3' },
            ]
          }
        },
        {
          label: '超时状态',
          child: {
            renderType: 'select',
            valueKey: 'timeout_state',
            options: [
              { label: '超时未处理', value: 'TIMEOUT_PENDING ' },
              { label: '超时未处理完', value: 'TIMEOUT_PROCESSING' },
            ]
          }
        },
        {
          label: '搜索',
          type: 'primary',
          renderType: 'search'
        },
        {
          label: '重置',
          renderType: 'reset'
        },
      ]
    }
  },
  mounted () {
    this.handleGetWxMerchantList()
  },
  methods: {
    // 获取微信号商户号下拉数据
    async getMerchantList () {
      const response = await getWxMerchantOptionsApi()
      const {  data = [] } = response.data
      this.wxMerchantOptionList = data
    },
    async handleGetWxMerchantList () {
      await this.getMerchantList()
      if (this.wxMerchantOptionList && this.wxMerchantOptionList.length) {
        this.wxMerchant = this.wxMerchantOptionList[0].company_name
        const { mch = [] } = this.wxMerchantOptionList[0]
        this.merchantList = mch
        this.selectMerchantId = mch[0].mch_id || ''
        this.searchForm.mch_id = mch[0].mch_id || ''

        this.handleGetTableData()
        this.getMerchantOverviewData()
      }
    },

    handleSelectMerchantChange (val) {
      const target = this.wxMerchantOptionList.find(it => it.company_name === val) || {}
      if (target.company_name) {
        const { mch = [] } = target
        this.merchantList = mch
        this.selectMerchantId = mch[0].mch_id || ''
        this.searchForm.mch_id = mch[0].mch_id || ''
        this.handleSearch()
        this.getMerchantOverviewData()
      }
    },

    // 获取商户总体数据概览
    getMerchantOverviewData () {
      if (!this.searchForm.mch_id) return

      wxMerchantComplaintOverviewDataApi({ mch_id: this.searchForm.mch_id }).then(res => {
        this.merchantOverviewData = res.data.data
      }).catch(() => {})
    },
    handleSearch () {
      this.searchForm.page = 1
      this.handleGetTableData()
    },
    handleReset () {
      this.searchForm = {
        ...new DefaultSearchForm(),
        mch_id: this.selectMerchantId
      }
      this.handleGetTableData()
      this.getMerchantOverviewData()
    },
    handleGetTableData () {
      const { mch_id, begin_date, end_date } = this.searchForm

      if (!mch_id) {
        this.$message.error('请选择商户')
        return
      }

      if (!begin_date || !end_date) {
        this.$message.error('请选择投诉时间')
        return
      }

      this.listLoading = true
      getWxMerchantComplaintListApi(this.searchForm).then(res => {
        const { data } = res.data
        this.tableData = data.data || []
        this.total = data.total || 0
        this.listLoading = false
      }).catch(() => { this.listLoading = false })
    },

    onPageChange (page) {
      this.searchForm.page = page.page || 1
      this.searchForm.limit = page.limit || 50
      this.handleGetTableData()
    },

    handleSelectMerchant (item) {
      this.selectMerchantId = item.mch_id
      this.searchForm.mch_id = item.mch_id
      this.handleGetTableData()
      this.getMerchantOverviewData()
    },

    // 飞书通知配置
    handleFsNotify () {
      this.$refs.fsNotify.triggleVisible();
    },

    // 查看投诉单详情
    handleSearchDetailInfo (row) {
      this.$refs.complaintFormDetail.triggleVisible({
        mch_id: this.selectMerchantId,
        complaint_id: row.complaint_id
      })
    },

    // 回复用户
    handleReplayUser (row) {
      this.$refs.replyUser.triggleVisible({
        mch_id: this.selectMerchantId,
        complaint_id: row.complaint_id
      })
    },

    handleReplaySuccess () {
      this.handleGetTableData()
      this.getMerchantOverviewData()
    },

    // 处理完成
    handleComplete (row) {
      this.$confirm('确认是否处理完成当前投诉？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }) .then(() => {
        wxMerchantCompleteApi({
          mch_id: this.searchForm.mch_id,
          complaint_id: row.complaint_id
        }).then(res => {
          this.$message.success('操作成功！')
          this.handleGetTableData()
          this.getMerchantOverviewData()
          // 重新获取商户号下拉数据，获取未处理的数据展示个数
          this.getMerchantList()
        }).catch(() => {})
      }) .catch(() => {});
    }
  }
};
</script>

<style lang="scss">
.wx-complain_content_ellipsis {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

</style>
<style lang="scss" scoped>
.wx-merchant-container {
  .wx-merchant-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

.wx-merchant-content {
  display: flex;
  // flex-direction: column;
  gap: 30px;
  margin-top: 15px;
  .merchant-list {
    min-width: 250px;
    width: 250px;
    height: 100%;
    min-height: 365px;
    background-color: #fff;
    border-radius: 5px;
    // padding: 0 10px;
    overflow: hidden;

    .select-merchant-item {
      background-color: #cde8f6;
    }

    .merchant-list-item {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 45px;
      line-height: 45px;
      border-bottom: 1px solid #e5e5e5;
      padding: 0 10px;
      box-sizing: border-box;
      cursor: pointer;

      .merchant-name {
        max-width: 180px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .merchant-count {
        color: red;
      }
    }
  }
  .merchant-search {
    flex: 1;
  }

  .merchant-search {
    width: 100%;
    .search-content-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .num-content {
        display: flex;
        gap: 20px;
        .num-content-item {
          font-size: 18px;
          font-weight: bold;
        }
      }
    }

    .search-content-table {
      margin-top: 15px;
      // width: 100%;
      .search-content-table-header {
        background: #fff;
        border-radius: 5px;
        padding: 20px;
        margin-bottom: 20px;
      }
    }
    .search-content-table-body {
      // width: 100%;
      background: #fff;
      border-radius: 5px;
      padding: 20px;
    }
  }
}
</style>